const MAX_LIST_ERROR_LEN = 280;

export const LLMS_TXT_GENERIC_ERROR =
	"We couldn't complete this request. Please try again later.";

const INTERNAL_ERROR_PATTERNS = [
	/insufficient_quota/i,
	/exceeded your current quota/i,
	/\bbilling\b/i,
	/\b429\b/,
	/rate limit/i,
	/openai\.com/i,
	/error code:/i,
	/api-errors/i,
	/['"]error['"]\s*:/,
	/\{'error'/,
];

export function isInternalLlmsTxtError(message) {
	if (!message || typeof message !== "string") {
		return false;
	}

	const trimmed = message.trim();
	if (!trimmed) return false;

	return INTERNAL_ERROR_PATTERNS.some((pattern) => pattern.test(trimmed));
}

export function formatLlmsTxtError(message, { maxLength = null } = {}) {
	if (!message || typeof message !== "string") {
		return "Something went wrong.";
	}

	const trimmed = message.trim();
	if (!trimmed) return "Something went wrong.";

	if (isInternalLlmsTxtError(trimmed)) {
		return LLMS_TXT_GENERIC_ERROR;
	}

	const embeddedMessage = trimmed.match(/['"]message['"]:\s*['"]([^'"]+)['"]/);
	if (embeddedMessage?.[1]) {
		if (isInternalLlmsTxtError(embeddedMessage[1])) {
			return LLMS_TXT_GENERIC_ERROR;
		}
		return embeddedMessage[1];
	}

	const limit = maxLength ?? trimmed.length;
	if (trimmed.length > limit) {
		return `${trimmed.slice(0, limit)}…`;
	}

	return trimmed;
}

export function formatLlmsTxtErrorForList(message) {
	return formatLlmsTxtError(message, { maxLength: MAX_LIST_ERROR_LEN });
}

export function shouldShowLlmsTxtErrorMessage(message) {
	if (!message || typeof message !== "string") {
		return false;
	}
	return !isInternalLlmsTxtError(message);
}

export function hasLlmsTxtErrorDetails(message, formatted) {
	if (!message || !formatted) return false;
	if (isInternalLlmsTxtError(message)) return false;
	return message.trim() !== formatted.trim();
}
